// @flow

import * as React from 'react';

type Props = {
  href: string,
  children: React.Node
};

export default function Link(props: Props) {
  return (
    <a
      {...props}
      className="lime hover-lime text-decoration-none hover-underline"
    />
  );
}
